import React from 'react';

function Footer() {
  return (
    <footer className="bg-dark text-center text-white" style={{ marginTop: "24px" }}>
      <div className="container p-4"></div>
      <div className="text-center p-3" style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}>
        © 2023 Copyright:
        <a className="text-white" href="#">ResumeParser.com</a>
      </div>
    </footer>
  )
}

export default Footer
